module.exports = __webpack_public_path__ + "static/media/Discipleship Groups.fcaecb0d.png";